export default __webpack_public_path__ + "static/media/wines-in-a-row.b38e67c8.png";